import React, { createContext } from "react";

export const PusherContext = createContext(null);

const PUSHER_CONFIG = process.env.REACT_APP_PUSHER_KEY;

export const PusherProvider = ({ children }) => {
  return (
    <PusherContext.Provider value={null}>{children}</PusherContext.Provider>
  );
};
